import type { ReactNode } from 'react';

/** Wrap every case-insensitive match in a highlight mark. */
export function highlightMatch(text: string, query: string): ReactNode {
  const q = query.trim();
  if (!q) return text;

  const parts: ReactNode[] = [];
  let remaining = text;
  let key = 0;
  const needle = q.toLowerCase();

  while (remaining.length > 0) {
    const idx = remaining.toLowerCase().indexOf(needle);
    if (idx === -1) {
      parts.push(remaining);
      break;
    }
    if (idx > 0) parts.push(remaining.slice(0, idx));
    parts.push(
      <mark key={key} className="saas-faq-exp__hl">
        {remaining.slice(idx, idx + q.length)}
      </mark>,
    );
    key += 1;
    remaining = remaining.slice(idx + q.length);
  }

  return <>{parts}</>;
}
